/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import type Router from '@ember/routing/router-service';
import { inject as service } from '@ember/service';

export default class FinAiAgentSuccessIndexRoute extends Route {
  @service declare router: Router;

  beforeModel() {
    this.router.replaceWith('apps.app.automation.fin-ai-agent.success.playbook');
  }
}
